import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import ItemsList from "./ItemsList";   
import './styles.css';

const MultiPair = ({
    itemsLists,
    hasSelectAll,
    onChange
}) => {

    const [checkedKeys, setCheckedKeys] = useState({});

    useEffect(() => {
        onChange(checkedKeys)
    }, [checkedKeys])

    const handleItemChecked = useCallback((listName, key) => {
        setCheckedKeys((prevCheckedKeys) => {
            const newCheckedKeys = { ...prevCheckedKeys };
            const prevListCheckedKeys = newCheckedKeys[listName] || {};
            const newListCheckedKeys = { ...prevListCheckedKeys };

            if (!newListCheckedKeys[key]) {
                newListCheckedKeys[key] = true;
            } else {
                delete newListCheckedKeys[key];
            }
            newCheckedKeys[listName] = newListCheckedKeys
            return newCheckedKeys;
        });
    }, []);

    const setBatchCheckedKeys = useCallback((listName, keys, checked) => {
        setCheckedKeys((prevCheckedKeys) => {
            const newCheckedKeys = { ...prevCheckedKeys }
            const prevListCheckedKeys = newCheckedKeys[listName] || {};
            const newListCheckedKeys = { ...prevListCheckedKeys };

            keys.forEach((key) => {
                if (checked) {
                    newListCheckedKeys[key] = true;
                } else {
                    delete newListCheckedKeys[key];
                }
            });

            newCheckedKeys[listName] = newListCheckedKeys;

            return newCheckedKeys;
        });
    }, []);

    const handleAllItemsChecked = useCallback((listName, keys, checked) => {
        setBatchCheckedKeys(listName, keys, checked);
    }, [setBatchCheckedKeys]);

    const listCheckedKeys = useCallback((listName) => {
        return checkedKeys[listName] || {}
    }, [checkedKeys])

    const internalItems = useCallback((listName, items, itemKeySelector) => {

        const _listCheckedKeys = listCheckedKeys(listName)

        return items.map((item) => {
            const key = itemKeySelector(item);
            return {
                key,
                value: item,
                checked: !!_listCheckedKeys[key],
            };
        });
    }, [checkedKeys]);


    console.log('checkedKeys: ', checkedKeys)
    console.log('itemsLists: ', itemsLists)

    return (

        <div className="transferContent">
            {
                itemsLists.map((list) => {
                    return (
                        <div className="targetItems" key={list.name}>
                            {list.listLabel && <label>{list.listLabel}</label>}
                            <ItemsList
                                key={list.name}
                                items={internalItems(list.name, list.items, list.itemKeySelector)}
                                onItemChecked={(key) => handleItemChecked(list.name, key)}
                                itemRender={list.itemRender}
                                hasSelectAll={hasSelectAll}
                                onAllItemsChecked={(keys, checked) => handleAllItemsChecked(list.name, keys, checked)}
                                hasSearch={list.hasSearch}
                                searchSelector={list.searchSelector}
                                disabled={list.disabled}
                            />
                        </div>
                    )
                })
            }
        </div>
    );
}

MultiPair.propTypes = {
    itemsLists: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasSelectAll: PropTypes.bool,
    onChange: PropTypes.func
};

MultiPair.defaultProps = {
    itemsLists: [],
    hasSelectAll: true,
};

export default MultiPair;